module.exports = __webpack_public_path__ + "img/member_cards_icon_ycq.e6a2e1cc.png";